import { render, staticRenderFns } from "./AreaList.vue?vue&type=template&id=b916a88e"
import script from "./AreaList.vue?vue&type=script&lang=js"
export * from "./AreaList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b916a88e')) {
      api.createRecord('b916a88e', component.options)
    } else {
      api.reload('b916a88e', component.options)
    }
    module.hot.accept("./AreaList.vue?vue&type=template&id=b916a88e", function () {
      api.rerender('b916a88e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/sys/area/AreaList.vue"
export default component.exports